module.exports = __webpack_public_path__ + "img/onboarding_back.98b5a53a.svg";